import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  UploadPayload,
  UploadState,
  ResetUploadPayload,
} from '@Typings/emailUpload.types';

const uploadSlice = createSlice({
  name: 'upload',
  initialState: {
    header: {
      data: [],
      isLoading: false,
    },
    footer: {
      data: [],
      isLoading: false,
    },
    listOfAttachments: {
      data: [],
      isLoading: false,
    },
  } as UploadState,
  reducers: {
    setUploadData: (
      state,
      { payload: { storeKey, attachment } }: PayloadAction<UploadPayload>
    ) => {
      state[storeKey] = {
        ...attachment,
      };
    },
    resetUploadData: (
      state,
      { payload: { storeKey } }: PayloadAction<ResetUploadPayload>
    ) => {
      if (storeKey) {
        state[storeKey] = {
          data: [],
          isLoading: false,
        };
      } else {
        state.header = {
          data: [],
          isLoading: false,
        };
        state.footer = {
          data: [],
          isLoading: false,
        };
        state.listOfAttachments = {
          data: [],
          isLoading: false,
        };
      }
    },
  },
});

export const { setUploadData, resetUploadData } = uploadSlice.actions;
export default uploadSlice.reducer;
